// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M_MQqKjca8M1O25J {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 {
  width: 480px;
  max-width: 92vw;
  height: auto;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 28px 28px 22px;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .hL_tJ769mwW8SjOQ {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #ffecec;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .RY_mBE5sCj4bbj8t {
  font-size: 28px;
  color: #ff4d4f;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .HrFUyZzVLUMUzTsx {
  font-size: 18px;
  font-weight: 700;
  color: #1f2a44;
  line-height: 1.35;
  margin-bottom: 10px;
  text-align: center;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .m0SQsjiRIiUA9UJP {
  text-align: center;
  font-size: 14px;
  line-height: 1.7;
  max-width: 400px;
  color: #5b6477;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .q_uBZyeRIahGplPR {
  color: #3a455d;
  font-weight: 700;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .hKlbntIBGrIrBYBR {
  color: #000;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .YFs3N4Pw2s0Ho6Cb {
  margin-top: 22px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding-bottom: 4px;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .YFs3N4Pw2s0Ho6Cb .diGkA2il6GQRBmUC {
  min-width: 112px;
  height: 40px;
  border-radius: 8px;
}
.M_MQqKjca8M1O25J .VIKc4ud9g4aHhlU2 .YFs3N4Pw2s0Ho6Cb .V68E91K47iAcUucc {
  min-width: 112px;
  height: 40px;
  border-radius: 8px;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/ComplaintConfirmModal/index.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AACF;AAbA;EAcI,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,8CAAA;AAEJ;AA3BA;EA4BM,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAEN;AArCA;EAuCM,eAAA;EACA,cAAA;AACN;AAzCA;EA4CM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAAN;AAjDA;EAqDM,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADN;AAxDA;EA6DM,cAAA;EACA,gBAAA;AAFN;AA5DA;EAiEM,WAAA;AAFN;AA/DA;EAoEM,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAFN;AAxEA;EA6EQ,gBAAA;EACA,YAAA;EACA,kBAAA;AAFR;AA7EA;EAmFQ,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAHR","sourcesContent":[".modalOverlay{\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 99;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  .modalOverlayContent{\n    width: 480px;\n    max-width: 92vw;\n    height: auto;\n    background: #fff;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    box-sizing: border-box;\n    padding: 28px 28px 22px;\n    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.12);\n    // background: rgb(254,226,226);\n    .modalOverlayContentImg{\n      width: 56px;\n      height: 56px;\n      border-radius: 50%;\n      background: #ffecec;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-bottom: 16px;\n    }\n\n    .modalOverlayContentIcon {\n      font-size: 28px;\n      color: #ff4d4f;\n    }\n\n    .modalTitle {\n      font-size: 18px;\n      font-weight: 700;\n      color: #1f2a44;\n      line-height: 1.35;\n      margin-bottom: 10px;\n      text-align: center;\n    }\n\n    .warningText{\n      text-align: center;\n      font-size: 14px;\n      line-height: 1.7;\n      max-width: 400px;\n      color: #5b6477;\n    }\n\n    .refundEmphasis {\n      color: #3a455d;\n      font-weight: 700;\n    }\n    .warningTextColor{   \n      color:#000;\n    }\n    .modalfooter{\n      margin-top: 22px;\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 12px;\n      padding-bottom: 4px;\n\n      .modalfooterBtnCancel {\n        min-width: 112px;\n        height: 40px;\n        border-radius: 8px;\n      }\n\n      .modalfooterBtnConfirm {\n        min-width: 112px;\n        height: 40px;\n        border-radius: 8px;\n        font-weight: 600;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `M_MQqKjca8M1O25J`,
	"modalOverlayContent": `VIKc4ud9g4aHhlU2`,
	"modalOverlayContentImg": `hL_tJ769mwW8SjOQ`,
	"modalOverlayContentIcon": `RY_mBE5sCj4bbj8t`,
	"modalTitle": `HrFUyZzVLUMUzTsx`,
	"warningText": `m0SQsjiRIiUA9UJP`,
	"refundEmphasis": `q_uBZyeRIahGplPR`,
	"warningTextColor": `hKlbntIBGrIrBYBR`,
	"modalfooter": `YFs3N4Pw2s0Ho6Cb`,
	"modalfooterBtnCancel": `diGkA2il6GQRBmUC`,
	"modalfooterBtnConfirm": `V68E91K47iAcUucc`
};
export default ___CSS_LOADER_EXPORT___;
